import type { LeaveMovement } from '../../types/domain';

// Journal du solde CP d'une personne, du plus récent au plus ancien. Le journal chargé contient
// tous les mouvements visibles (manager, valideur) : chaque écran n'affiche que ceux de la personne.
export function leaveMovementsOf(
  movements: LeaveMovement[] | null | undefined,
  userId: string | null | undefined,
): LeaveMovement[] {
  return (movements || [])
    .filter((m) => m.user_id === userId)
    .sort((a, b) => b.created_at.localeCompare(a.created_at) || b.id - a.id);
}

// « 4,08 j », « −1,34 j » : solde en jours, à la française, au centième (crédit mensuel de 2,08).
export function formatLeaveBalance(days: number | string | null | undefined): string {
  const n = Number(days) || 0;
  return `${n < 0 ? '−' : ''}${Math.abs(n).toLocaleString('fr-FR', { maximumFractionDigits: 2 })} j`;
}

// « +2,08 j », « −2 j » : le signe dit si le mouvement a ajouté ou retiré des jours.
export function formatLeaveDays(days: number | string): string {
  const n = Number(days) || 0;
  return n < 0 ? formatLeaveBalance(n) : `+${formatLeaveBalance(n)}`;
}
